import { createEntityAdapter, EntityState, Update } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { programmeProjectSelectionUnapplied } from '@state/account/account.actions';
import {
  listCameraSets,
  listCameraSetsSuccess,
  listCameraSetsFailure,
  createCameraSuccess,
  updateCameraSuccess,
  deleteCameraSuccess,
} from '@state/camera-sets/camera-sets.actions';
import { Camera, CameraSet } from '@state/camera-sets/camera-sets.interfaces';


export const featureKey = 'cameraSets';
export const adapter = createEntityAdapter<CameraSet>({
  selectId: (cameraSet: CameraSet) => cameraSet.uuid,
});

export const cameraAdapter = createEntityAdapter()

export interface State extends EntityState<CameraSet> {
  loading: boolean;
  loaded: boolean;
}
export const initialState: State = adapter.getInitialState({
  loaded: false,
  loading: false,
});

export const reducer = createReducer(
  initialState,

  on(listCameraSets, (state) => ({ ...state, loading: true })),
  on(listCameraSetsSuccess, (state, { cameraSets }) => adapter.setAll(cameraSets, { ...state, loading: false, loaded: true })),
  on(listCameraSetsFailure, (state) => ({ ...state, loading: false })),

  on(createCameraSuccess, (state, { cameraSet, camera }) => adapter.updateOne(
    {
      id: cameraSet,
      changes: { cameras: (state.entities[cameraSet]?.cameras || []).concat(camera) }
    }, state
  )),

  on(updateCameraSuccess, (state, { camera }) => adapter.updateMany(
    Object.values(state.entities).reduce(
      (changes: Update<CameraSet>[], cameraSet: CameraSet|undefined) => {
        const matchedCamera: Camera|undefined = cameraSet?.cameras.find(({ uuid }) => uuid === camera.uuid);
        if (matchedCamera && cameraSet) {
          const update = {
            id: cameraSet.uuid,
            changes: {
              cameras: cameraSet.cameras.map(existingCamera => existingCamera.uuid === camera.uuid ? camera : existingCamera)
            }
          } as Update<CameraSet>;
          changes.push(update);
        }
        return changes;

      },
      []
    ), state
  )),

  on(deleteCameraSuccess, (state, { cameraSet, uuid }) => adapter.updateOne(
    {
      id: cameraSet,
      changes: { cameras: (state.entities[cameraSet]?.cameras || []).filter(camera => camera.uuid !== uuid) }
    }, state
  )),

  // Clear State
  on(programmeProjectSelectionUnapplied, () => ({ ...initialState })),
);
